module.exports = __webpack_public_path__ + "static/media/delete-icon.54311a16.svg";